import React, {useState, useRef} from 'react';
import styles from './AddRateModal.module.scss';
import {useSelector} from 'react-redux';
import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import {selectMediakitUser} from './../../features/stores/mediakitUser.slice';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PlatformSelector from './component/PlatformSelector';
import ContentSelector from './component/ContentSelector';
import CurrencySelector from './component/CurrencySelector';
import AmountInput from './component/AmountInput';
import PriceBreakDown from './component/PriceBreakdown';
import {RatesModalData, socialMediaLinks} from '../../constants/socialMedia';

interface IProps{
    handleClose: () => void;
    orderNumber: number;
    handleAddRate: Function;
};

const ButtonCustom = styled(Button)({
  background: '#7066FF',
  color: '#fff',
  padding: '16px 24px',
  borderRadius: '40px',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '24px',
  textTransform: 'capitalize',
});

const AddRateModal = ({handleClose, orderNumber, handleAddRate}: IProps) => {
  const {t} = useTranslation();
  const [currentView, setCurrentView] = useState('CHOOSE-LINK');
  const mediakitUser = useSelector(selectMediakitUser);
  const socialSectionData = mediakitUser.mediakitSection.find(
    (section: any) => section.type === 'rates',
    );
  const [addObj, setAddObj] = useState<any>({});
  const node = useRef(null);
  const handleBackwardClick = () => {
    if (currentView == 'ADD-LINK') {
        setCurrentViewHandle('CHOOSE-LINK');  
    }
  };
  const determineIcon = () => {
    return socialMediaLinks.find((e: any) => e.key === addObj?.type)?.defaultIconTransparent;
  };

  const handleChangeUrl = (url: any) => {
    setAddObj({...addObj, url: url});
  };

  const setCurrentViewHandle = (value: string, platform?: string) => {
    if (value == 'ADD-LINK') {
        const obj = {
            id: Date.now(), // id generated via UTC date (unique), so that we can later delete this item (this id is not sent do backend)
            url: '',
            orderNumber: orderNumber || 0,
            mediakitSectionId: socialSectionData?.id,
            platform: platform,
            contentType: '',
            description: '',
            currency: 'usd',
            price: 0,
            isVisible: true,
        };
        setAddObj(obj);  
    }
    setCurrentView(value);
  };

  const handleAddNewRate = () => {
    handleAddRate({...addObj, price: addObj?.price * 100}, true);
     handleClose();
  };

  const getContentBody = () => {
    switch (currentView) {
        case 'CHOOSE-LINK': 
            return <>
            <div className={styles.head_container}>
                <div className={styles.head_left}>
                    <div className={styles.text_center}>{t('choose_social_media')}</div>
                    <div className={styles.quick_link}>{t('share_content_directly_on_your_Alfan_media_kit')}</div>
                </div>
            </div>
            <div className={styles.box_body}>
                {RatesModalData.map((platform) => {
                    return (
                    <div className={styles.row} key={platform.key} onClick={()=>setCurrentViewHandle('ADD-LINK', platform.key)}>
                        <div className={styles.left}>
                            <div className={styles.image_container}>
                                <img src={platform.defaultIcon} />
                            </div>
                            <div className={styles.title_container}>
                                <div className={styles.title}>{platform.name}</div>
                                <div className={styles.subtitle}>{t(platform.subTitle)}</div>
                            </div>
                        </div>
                        <div className={styles.right}>
                            <ChevronRightIcon />
                        </div>
                    </div>
                    );
                })}  
            </div>
            </>; 
        case 'ADD-LINK': 
            const linkType = socialMediaLinks.find((e: any) => e.key === addObj.type)?.name;
            return <>
            <div>
                <div className={styles.text_center}>{t('add_your_rates')}</div>
                <div className={styles.head_subtitle}>{t('get_promote_at_my_social_accounts')}</div>
            </div>
            <div className={`${styles.box_body_link}`}>
              <div className={styles.single_row}>
                <div className={styles.box_title}>{t('social_media')}</div>
                <PlatformSelector setAddObj={setAddObj} selectValue={addObj} />
              </div>
              <div className={styles.single_row}>
                <div className={styles.box_title}>{t('content_type')}</div>
                <ContentSelector setAddObj={setAddObj} selectValue={addObj} />
              </div>
              <div className={styles.single_row}>
                <div className={styles.box_title}>{t('give_your_buyer_a_small_teaser')}</div>
                <textarea value={addObj.description as string} className={styles.bio_input} onChange={(e: any)=>{
                      const value = e.target.value;
                      value?.length < 171 ? setAddObj({...addObj, description: e.target.value}) : '';
                    }} />
                <div className={styles.description_length}>{addObj?.description?.length}/170</div>
              </div>
              <div className={styles.single_row}>
                <div className={styles.box_title}>{t('price')}</div>
                <div className={styles.price_nested}>
                  <div><CurrencySelector setAddObj={setAddObj} selectValue={addObj} /></div>
                  <div className={styles.width_full}><AmountInput setAddObj={setAddObj} selectValue={addObj} /></div>
                </div>
              </div>
              <div className={styles.single_row} style={{marginTop: '12px'}}>
                <PriceBreakDown selectValue={addObj} />
              </div>
            </div>
            <div className={styles.add_footer}>
                 <ButtonCustom disabled={addObj.price <=1 || addObj.price > 50000} onClick={handleAddNewRate} variant="contained" size="large">{t('publish')}</ButtonCustom>
            </div>
            </>;             
        default:
            break;       
   } 
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.modal}>
          <div className={`${styles.modal_content} ${currentView == 'ADD-LINK' ? styles.add_link : ''}`}>
              <div className={styles.cross} onClick={handleClose}><CloseIcon /></div>
              <div className={styles.content_body}>
                {getContentBody()}
              </div>
              
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRateModal;
